function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3H21ZM21 6.414L13.4142 14C12.6743 14.7399 11.4988 14.7789 10.713 14.1168L10.5858 14L3 6.415V19H21V6.414ZM19.584 5H4.415L12 12.5858L19.584 5Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4H0L12 11.0872L24 4ZM12 12.5906L0 5.61074V20H24V5.61074L12 12.5906Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3H21ZM21 6.414L13.4142 14C12.6743 14.7399 11.4988 14.7789 10.713 14.1168L10.5858 14L3 6.415V19H21V6.414ZM19.584 5H4.415L12 12.5858L19.584 5Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 4V20H23V4H1ZM21.7 5.29999V6.29001L12 11.89L2.3 6.29001V5.29999H21.7ZM2.3 18.7V7.79001L12 13.39L21.7 7.79001V18.7H2.3Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4H0L12 11.0872L24 4ZM12 12.5906L0 5.61074V20H24V5.61074L12 12.5906Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0009 0C18.6281 0 24 5.3725 24 11.9991C24 18.6266 18.6281 24 12.0009 24C5.37322 24 0 18.6266 0 11.9991C0 5.3725 5.37322 0 12.0009 0ZM19.6752 15.0339C20.2183 14.4684 20.6451 13.8025 20.9546 13.0325C21.2632 12.2618 21.4189 11.4372 21.4189 10.556C21.4189 9.30375 21.1915 8.18746 20.7379 7.20323C20.283 6.22027 19.6588 5.3881 18.8609 4.70671C18.0622 4.02532 17.1204 3.50265 16.0327 3.13913C14.9468 2.77341 13.7717 2.59243 12.5066 2.59243C11.1728 2.59243 9.90721 2.82296 8.70986 3.28233C7.51464 3.74481 6.46091 4.40075 5.55433 5.25348C4.64727 6.10706 3.92344 7.13857 3.38704 8.34752C2.8505 9.55832 2.58304 10.9145 2.58304 12.4142C2.58304 13.8846 2.81619 15.1824 3.28482 16.3027C3.75048 17.4229 4.40108 18.3621 5.23279 19.1185C6.06444 19.8757 7.05005 20.4457 8.18409 20.8306C9.31764 21.2159 10.5525 21.4089 11.8863 21.4089C12.644 21.4089 13.3142 21.3527 13.8985 21.2435C14.4839 21.1324 15.0578 20.9407 15.6211 20.6664L14.9825 18.685C14.5691 18.8781 14.1081 19.0213 13.6006 19.1185C13.0904 19.2143 12.6378 19.2621 12.2377 19.2621C11.0547 19.2621 10.0057 19.1006 9.09201 18.7773C8.17736 18.4549 7.41036 17.9937 6.79223 17.3953C6.17197 16.7959 5.701 16.0725 5.37818 15.2181C5.05579 14.3658 4.89346 13.4026 4.89346 12.33C4.89346 11.2441 5.08606 10.2349 5.47048 9.30723C5.85667 8.37879 6.3891 7.57738 7.06869 6.90258C7.75055 6.23013 8.55107 5.70037 9.47331 5.31409C10.3951 4.92966 11.3931 4.73705 12.4647 4.73705C13.3994 4.73705 14.2739 4.84849 15.0855 5.06881C15.8959 5.28737 16.6013 5.63565 17.1998 6.11061C17.7969 6.58372 18.2687 7.18621 18.613 7.91411C18.9563 8.6432 19.1289 9.52401 19.1289 10.556C19.1289 11.2713 19.0437 11.8894 18.8711 12.4142C18.7008 12.9366 18.4756 13.3682 18.2018 13.7116C17.9254 14.0568 17.6158 14.311 17.2725 14.4751C16.93 14.641 16.5777 14.723 16.221 14.723C15.8623 14.723 15.6332 14.5794 15.5289 14.2909C15.4271 14.0024 15.4298 13.5341 15.539 12.887L16.5295 7.29552H15.0855L14.4464 7.95643C14.1696 7.72277 13.8672 7.53456 13.5381 7.38967C13.2081 7.24427 12.8018 7.17288 12.3197 7.17288C11.6196 7.17288 10.9556 7.36244 10.3308 7.73972C9.70383 8.11834 9.15397 8.61563 8.67902 9.23591C8.20415 9.854 7.83037 10.5662 7.55441 11.3703C7.281 12.1748 7.14184 13.0034 7.14184 13.857C7.14184 14.311 7.20699 14.723 7.33898 15.095C7.46877 15.466 7.64493 15.7836 7.86432 16.0448C8.08506 16.3044 8.34593 16.5073 8.64698 16.6527C8.95066 16.7959 9.26682 16.8695 9.59772 16.8695C10.0094 16.8695 10.387 16.8066 10.7318 16.6836C11.0751 16.5604 11.3931 16.3919 11.6812 16.1778C11.9697 15.9646 12.2346 15.7202 12.4754 15.4455C12.7167 15.1704 12.9397 14.8885 13.1453 14.6009H13.2286C13.1858 15.0254 13.2134 15.3844 13.3106 15.6725C13.4065 15.9611 13.5545 16.1948 13.7544 16.3745C13.9529 16.5538 14.2003 16.6799 14.4973 16.7553C14.793 16.832 15.1123 16.8695 15.457 16.8695C16.2806 16.8695 17.0553 16.7041 17.7781 16.3745C18.4993 16.0448 19.1325 15.5971 19.6752 15.0339ZM12.5066 9.31798C12.7951 9.31798 13.0364 9.3586 13.2286 9.44055C13.42 9.52398 13.6064 9.64039 13.7856 9.79251L13.2697 12.6395C13.118 12.9143 12.9454 13.1756 12.7541 13.4235C12.5611 13.6714 12.3617 13.8909 12.1566 14.0826C11.9483 14.2771 11.736 14.4305 11.5161 14.5464C11.2972 14.6651 11.089 14.723 10.8981 14.723C10.4433 14.723 10.1244 14.5776 9.93756 14.2909C9.75162 14.0002 9.65925 13.63 9.65925 13.1756C9.65925 12.735 9.72794 12.2854 9.86617 11.8247C10.0026 11.3636 10.1993 10.9489 10.4535 10.5761C10.7081 10.2037 11.01 9.9031 11.3623 9.66938C11.7124 9.43396 12.0932 9.31798 12.5066 9.31798Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS2023, MBNA } from "../../constants";
export default function Email(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.email) {
    svg = theme.assets.icons.email;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      default:
        console.warn("Icon \"Email\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}